/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
"use client";

import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";

export function HubOffTheTrackPage({ htmlContent }: { htmlContent: string }) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      onClick={(e: any) => {
        if (e.target.href) {
          CreateAnalyticEvent({
            event: {
              adIds: ["NONE"],
              eventType: "CLICK#LINK#OUT",
              metadata: {
                href: e.target.href,
                text: e.target.textContent || "NONE",
              },
            },
          });
        }
      }}
    />
  );
}
